import styled from 'styled-components'

interface InputProps {
  color?: string
  placeholdercolor?: string
  padding?: string
}

export const Input = styled.input<InputProps>`
  width: 100%;
  height: 100%;
  padding: ${(props) => (props.padding ? props.padding : '0.625rem 0.875rem')};
  border: none;
  outline: none;
  background: inherit;
  color: ${(props) =>
    props.color ? props.color : props.theme.color.neutral.gray};

  &::placeholder {
    color: ${(props) =>
      props.placeholdercolor
        ? props.placeholdercolor
        : props.theme.color.neutral.gray};
    opacity: 0.8;
  }

  &:disabled {
    border: 1px solid #cecece;
    background: #ddd;
  }

  &[type='password'] {
    &:invalid {
      border: 1px solid ${(props) => props.theme.color.red.red600};
    }
  }
  &[type='file'] {
    opacity: 0;
    cursor: pointer;
  }
`
